<template>
	<div class="deals-slider">
		<div class="intro">
			<h2 v-html="title"></h2>
			<router-link :to="viewAllUrl" v-if="showViewAll">View All</router-link>
		</div>
		<div class="track-wrap">

			<!--------------------------------------------------
				Slider
			----------------------------------------------------->
			<div class="track" ref="slide" :id="key">
				<Deal v-for="deal in deals" :key="deal.deal_id" :deal="deal" />
			</div>

			<!--------------------------------------------------
				Prev/Next Buttons
			----------------------------------------------------->
			<button class="slider-nav prev" ref="prev" v-if="deals.length > 0"><i class="fas fa-angle-left"></i></button>
			<button class="slider-nav next" ref="next" v-if="deals.length > 0"><i class="fas fa-angle-right"></i></button>

			<!--------------------------------------------------
				Loading State
			----------------------------------------------------->
			<div class="loader" v-if="isLoading">
				<LoadingWheel />
			</div>
		</div>
	</div>
</template>

<script>
import LoadingWheel from '@/components/LoadingWheel';
import Glider from 'glider-js';
import Deal from './Deal.vue';
// import $ from 'jquery';
// import 'slick-carousel';
const axios = require('axios');

//
export default {
	name: "DealsSlider",
	created() {
		this.key = ['deal-slider', Math.floor(Math.random() * (9999 - 1000) + 1000)].join("-");
		this.getDeals();
	},
	components: {
		LoadingWheel,
		Deal
	},
	props: {
		title: {
			type: String,
			default: "Deals"
		},
		params: {
			type: Object,
			default: {}
		},
		showViewAll: {
			type: Boolean,
			default: true
		},
		viewAllUrl: {
			default: "#"
		}
	},
	data: function() {
		return {
			key: false,
			isLoading: true,
			deals: [],
			slider: null
		}
	},
	computed: {
		dealsCount() {
			return this.deals.length;
		}
	},
	watch: {
		dealsCount() {
			if( this.deals.length > 0 ) {
				setTimeout(() => {
					this.slider = new Glider(this.$refs.slide, {
						slidesToShow: 1,
						slidesToScroll: 1,
						// itemWidth: 300,
						// scrollLock: true,
						dragVelocity: .5,
						draggable: true,
						responsive: [
							{
								breakpoint: 480,
								settings: {}
							},
							{
								breakpoint: 768,
								settings: {
									slidesToShow: 2,
									slidesToScroll: 2
								}
							},
							{
								breakpoint: 1024,
								settings: {
									slidesToShow: 3,
									slidesToScroll: 3,
									draggable: false
								}
							},
							{
								breakpoint: 1325,
								settings: {
									slidesToShow: 5,
									slidesToScroll: 5,
									draggable: false
								}
							}
						],
						arrows: {
							prev: this.$refs.prev,
							next: this.$refs.next
						}
					});
					this.isLoading = false;
				}, 10);
			}
		}
	},
	methods: {

		getDeals() {

			this.$store.dispatch('getDeals', this.params)
				.then(deals => {
					this.deals = deals.data;
				})
				.catch(e => {});

		},

	}
};
</script>

<style lang="scss">
.deals-slider {
	position: relative;
	// overflow: hidden;
	margin-bottom: 30px;

	.intro {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
		border-bottom: rgb(147, 146, 146) 1px solid;
		margin-bottom: 20px;
		padding-bottom: 4px;

		a {
			text-decoration: none;
			color: #333;
		}
	}

	.track-wrap {
		position: relative;
		padding: 0 30px;
		.slider-nav {
			position: absolute;
			top: 50%;
			cursor: pointer;
			background: none;
			border: none;
			font-size: 40px;
			z-index: 25;
			margin-top: -60px;
			color: #84878e;
			outline-style: none;

			&.prev { left: -15px; }
			&.next { right: -15px; }
		}
	}

	.track {
		position: relative;
		min-height: 340px;
		
		>* {
			visibility: hidden;
		}

		&.glider {
			>* {
				visibility: visible;
			}
		}

		.glider-track {}

		.deal-box {
			margin-bottom: 0;
		}
	}

	.loader {
		position: absolute;
		top: -15px;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		span {
			font-size: 21px;
			color: #84878e;
		}
	}

	.deal-box {
		// flex-shrink: 0;
		margin: 0 15px;
		&:first-child {
			// margin-left: 0;
		}
	}

	//
	@media ( min-width: 1400px ) {
		.track-wrap {
			padding: 0;
			.slider-nav {
				&.prev { left: -40px; }
				&.next { right: -40px; }
			}
		}
	}
}
</style>